import React from 'react';
import s from '../../../PersonalOffice/PaperworkList/PaperworkList.module.css';
import {useFormikContext} from 'formik';
import {useTranslation} from 'react-i18next';
import FilterDay from './FilterDay';
type Props = {
	toDateFieldName: string;
	byDateFieldName: string;
};
const FromDateToDateFilter: React.FC<Props> = ({
	toDateFieldName,
	byDateFieldName,
}) => {
	const {t} = useTranslation();
	const {setFieldValue} = useFormikContext<any>();
	return (
		<div className={s.dateRangeContainer}>
			<div>
				<FilterDay
					inputName={byDateFieldName}
					setFieldValue={setFieldValue}
					label={t('Від дати')}
				/>
			</div>
			<div>
				<FilterDay
					inputName={toDateFieldName}
					setFieldValue={setFieldValue}
					label={t('По дату')}
				/>
			</div>
		</div>
	);
};

export default FromDateToDateFilter;
